import React, { useMemo, useState } from 'react';
import TagIcon from '@heroicons/react/outline/TagIcon.js';
import debounce from 'lodash/debounce.js';
import { T, useI18n } from '@tribeplatform/react-components/i18n';
import { useSpaceTags } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { MultiselectCreatable } from '@tribeplatform/react-ui-kit/Multiselect';
const tagTitleIdMap = {};
export const SpaceTagsSelector = ({ spaceId, tags, setTags, createable = true, className = '', placement, }) => {
    const { $t } = useI18n();
    const [query, setQuery] = useState('');
    const { data, isFetching } = useSpaceTags({
        variables: {
            spaceId,
            limit: 10,
            query,
        },
    });
    const { nodes: spaceTags } = simplifyPaginatedResult(data);
    const options = useMemo(() => (spaceTags === null || spaceTags === void 0 ? void 0 : spaceTags.map(t => t.title)) || [], [spaceTags]);
    const value = useMemo(() => tags.map(tag => tag === null || tag === void 0 ? void 0 : tag.title), [tags]);
    useMemo(() => {
        tags.forEach(t => {
            tagTitleIdMap[t.title] = t.id;
        });
        spaceTags === null || spaceTags === void 0 ? void 0 : spaceTags.forEach(t => {
            tagTitleIdMap[t.title] = t.id;
        });
    }, [tags, spaceTags]);
    const onChange = newTags => {
        setTags(newTags.map(title => ({
            title,
            id: tagTitleIdMap[title],
        })));
    };
    const onCreateItem = inputValue => {
        if (createable) {
            setTags([
                ...tags,
                {
                    title: inputValue,
                    id: `local-${Math.random().toString(36).substr(2, 5)}`,
                },
            ]);
        }
    };
    const onInputChange = debounce(inputValue => {
        setQuery(inputValue);
    }, 500);
    return (React.createElement(MultiselectCreatable, { options: options, value: value, onChange: onChange, className: className, searchable: true, onInputChange: onInputChange, onCreateItem: onCreateItem, createItemPosition: "first", placement: placement },
        React.createElement(MultiselectCreatable.Button, { placeholder: $t({
                defaultMessage: 'Add {TAGS}...',
                id: 'Blocks.HighlightedTags.AddTagsDotDotDot',
            }), dense: true, leadingIcon: isFetching ? (React.createElement(SpinnerIcon, { className: "self-center h-5 w-5 animate-spin" })) : (React.createElement(TagIcon, { className: "h-5 w-5" })) }),
        React.createElement(MultiselectCreatable.Items, { style: { maxHeight: '200px' } }, ({ creating, inputValue }) => {
            return (React.createElement(React.Fragment, null,
                createable && creating && (query === null || query === void 0 ? void 0 : query.length) > 0 && !isFetching && (React.createElement(MultiselectCreatable.Item, { value: query, index: 0 },
                    React.createElement("span", null,
                        React.createElement(T, { id: "Generics.Create", defaultMessage: "Create" })),
                    ' ',
                    React.createElement("span", { className: "font-bold" }, query))),
                options.length > 0 &&
                    options.map((tag, index) => (React.createElement(MultiselectCreatable.Item, { key: tag, value: tag, index: index + (creating ? 1 : 0) },
                        React.createElement("span", null, tag)))),
                isFetching ? (React.createElement(MultiselectCreatable.Item, { disabled: true, key: ":_search", value: ":_search", index: creating ? 1 : 0 },
                    React.createElement("span", null,
                        React.createElement(T, { id: "Blocks.HighlightedTags.SearchingForTerm", defaultMessage: "Searching for {term}...", values: { term: inputValue } })))) : (options.length === 0 && (React.createElement(MultiselectCreatable.Item, { disabled: true, key: ":_none", value: ":_none", index: creating ? 1 : 0 },
                    React.createElement("span", null,
                        React.createElement(T, { id: "Blocks.HighlightedTags.NoMatchingResultForItem", defaultMessage: "No matching result for {term}", values: { term: inputValue } })))))));
        })));
};
//# sourceMappingURL=SpaceTagsSelector.js.map